export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    id: 'faq1',
    question: '17c·moc起草糖心在线看是什么平台？',
    answer: '17c·moc起草糖心在线看是一个免费的高清视频在线播放平台，提供海量电影、电视剧、综艺、动漫、纪录片等各类视频资源。用户无需下载，即可通过浏览器随时随地在手机、平板、电脑等多终端畅享流畅的高清观看体验。平台内容持续更新，致力于为用户打造最便捷、最优质的在线视频服务。',
  },
  {
    id: 'faq2',
    question: '如何在17c·moc起草糖心在线看免费观看视频？',
    answer: '访问17c·moc起草糖心在线看官方网站首页，您可以通过分类导航或搜索功能找到感兴趣的视频内容。点击视频封面即可进入播放页面，无需注册登录，完全免费观看。平台支持自适应码率技术，会根据您的网络状况自动调整画质，确保流畅播放。',
  },
  {
    id: 'faq3',
    question: '糖心在线看支持哪些设备观看？',
    answer: '糖心在线看采用响应式网页设计技术，全面兼容PC端（Windows/Mac）、移动端（iOS/Android手机和平板）、智能电视等多种设备。只需使用现代浏览器（如Chrome、Safari、Edge、Firefox等）访问即可，无需安装任何APP或插件。',
  },
  {
    id: 'faq4',
    question: '视频画质最高支持多少？',
    answer: '17c·moc起草糖心在线看的视频内容最高支持4K超高清画质。平台采用先进的视频编码技术和CDN加速分发，在保证画质的同时优化带宽消耗。系统会根据您的设备屏幕分辨率和网络带宽自动选择最合适的画质档位，您也可以手动切换画质。',
  },
  {
    id: 'faq5',
    question: '糖心在线看的内容多久更新一次？',
    answer: '我们每天都会更新内容，热门电影、剧集和综艺节目通常在上线后24小时内同步更新。纪录片和动漫内容也会定期更新，确保您能够第一时间看到最新、最热门的视频内容。建议您收藏糖心在线看官网，随时获取最新更新。',
  },
  {
    id: 'faq6',
    question: '观看视频需要安装播放器吗？',
    answer: '完全不需要。17c·moc起草糖心在线看采用HTML5网页播放技术，在任何现代浏览器中都能直接播放视频，无需下载或安装任何第三方播放器软件。我们的播放器界面简洁易用，支持倍速播放、记忆播放进度、画面调节等实用功能。',
  },
  {
    id: 'faq7',
    question: '如何联系糖心在线看官方？',
    answer: '您可以通过关于我们页面的联系方式与我们取得联系。我们提供电子邮件、在线客服等沟通渠道。如有任何问题或建议，欢迎随时联系我们，我们会在24小时内给予回复。',
  },
  {
    id: 'faq8',
    question: '糖心在线看的视频可以下载吗？',
    answer: '17c·moc起草糖心在线看是一个在线视频播放平台，专注于提供流畅的在线观看体验。目前平台不支持视频下载功能，但我们提供记忆播放进度功能，您可以在不同设备上随时接续上次的观看进度。',
  },
];